<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Start Table -->
            <div
              id="datatable_wrapper"
              class="dataTables_wrapper dt-bootstrap4 no-footer"
            >
              <div class="row">
                <div class="col-sm-12 col-md-5">
                  <div class="dataTables_length" id="datatable_length">
                    <label
                      >Show
                      <select
                        name="datatable_length"
                        aria-controls="datatable"
                        v-model="perPage"
                        class="
                          custom-select custom-select-sm
                          form-control
                          form-control-sm
                          form-select
                          form-select-sm
                        "
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      entries</label
                    >
                  </div>
                </div>
                <div class="col-sm-12 col-md-7">
                  <div class="row">
                    <div class="col-sm-12 col-md-9">
                      <div id="datatable_filter" class="dataTables_filter h-100">
                        <label class="h-100"
                          >Search:<input
                            type="search"
                            class="form-control form-control-sm h-100"
                            placeholder=""
                            aria-controls="datatable"
                            v-model.trim="search"
                        /></label>
                      </div>
                    </div>

                    <div class="col-sm-12 col-md-3">
                      <button
                        type="button"
                        @click="
                          $router.push({ path: '/mpg/opportunities/new' })
                        "
                        class="btn btn-success waves-effect waves-light w-100"
                      >
                        Create Opportunity
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <b-table
                    class="
                      table
                      mt-2
                      dt-responsive
                      nowrap
                      w-100
                      dataTable
                      no-footer
                      dtr-inline
                    "
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    :fields="column"
                    id="datatable"
                    :items="items"
                    :per-page="perPage"
                    :busy="loading"
                    show-empty
                    @sort-changed="sortChanged"
                  >
                    <template #cell(opportunity_name)="data">
                      <router-link
                        :to="
                          '/mpg/opportunities/' +
                          data.item.opportunity_id +
                          '/details'
                        "
                      >
                        {{ data.value }}
                      </router-link>
                    </template>
                    <template #cell(tags)="data">
                      <template v-for="(item, index) in data.value">
                        <span
                          class="badge badge-sm me-2"
                          :style="'background-color:' + item.color"
                          :key="index"
                        >
                          {{ item.name.toUpperCase() }}</span
                        >
                      </template>
                    </template>
                    <template #table-busy>
                      <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle mr-2"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="row" v-if="rows > 0">
                <div class="col-sm-12 col-md-5">
                  <div
                    class="dataTables_info"
                    id="datatable_info"
                    role="status"
                    aria-live="polite"
                  >
                    Showing {{ (currentPage - 1) * perPage + 1 }} to
                    {{
                      currentPage * perPage > rows
                        ? rows
                        : currentPage * perPage
                    }}
                    of {{ rows }} entries
                  </div>
                </div>
                <div class="col-sm-12 col-md-7">
                  <div
                    class="dataTables_paginate paging_simple_numbers"
                    id="datatable_paginate"
                  >
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="my-table"
                      v-on:change="onPageChange"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End Card Body -->
        </div>
      </div>
      <!-- End Col -->
    </div>
  </div>
</template>

<script>
import { opportunityService } from '../services/opportunities.service'
import { debounce } from '../helpers'
import moment from 'moment'

export default {
  name: 'Opportunities',
  props: ['isShowHeader'],
  components: {},
  watch: {
    search: debounce(function (newVal) {
      this.loadOpportunity()
    }, 500),
    perPage (newVal) {
      this.loadOpportunity()
    },
    sortBy (newVal) {
      this.loadOpportunity()
    },
    sortDesc (newVal) {
      this.loadOpportunity()
    }
  },
  data () {
    return {
      perPage: 10,
      currentPage: 1,
      items: [],
      count: 0,
      search: '',
      column: [
        {
          key: 'opportunity_name',
          sortable: true,
          label: 'Opportunity Name',
          class: 'sorting'
        },
        {
          key: 'tags',
          sortable: true,
          label: 'Tags',
          class: 'sorting'
        },
        {
          key: 'sales_annual_volume_manual',
          sortable: true,
          label: 'Annual Volume',
          class: 'sorting'
        },
        {
          key: 'pricing_due_date',
          sortable: true,
          label: 'Due Date',
          class: 'sorting',
          formatter (value) {
            return value ? moment(value).format('MMMM DD, YYYY HH:mm A') : ''
          }
        },
        {
          key: 'created_at',
          sortable: true,
          label: 'Created at',
          class: 'sorting',
          formatter (value) {
            return moment(value).format('MMMM DD, YYYY HH:mm A')
          }
        },
        {
          key: 'modified_at',
          sortable: true,
          label: 'Modified at',
          class: 'sorting',
          formatter (value) {
            return moment(value).format('MMMM DD, YYYY HH:mm A')
          }
        },
        {
          key: 'sales_represented',
          sortable: true,
          label: 'Sales Person Represented',
          class: 'sorting'
        }
      ],
      sortBy: 'opportunity_name',
      sortDesc: false,
      tagList: [],
      loading: true
    }
  },
  computed: {
    rows () {
      return this.count
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    moment,
    loadData () {
      this.loading = true
      // utilService.getTag().then((tags) => {
      // this.tagList = tags.results;
      this.loadOpportunity()
      // });
    },
    loadOpportunity () {
      this.loading = true
      opportunityService
        .getData({
          q: 'q=' + this.search,
          ordering: this.sortDesc ? '-' + this.sortBy : this.sortBy,
          limit: this.perPage,
          offset: (this.currentPage - 1) * this.perPage
        })
        .then((rs) => {
          this.items = rs.results
          this.loading = false
          this.count = rs.count
        })
    },
    onPageChange (value) {
      this.currentPage = value
      this.loadOpportunity()
    },
    sortChanged (e) {
      this.sortDesc = e.sortDesc
      this.sortBy = e.sortBy
    },
    onSubmit () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Opportunities.vue